import moment from "moment";
var _currencyType = "Rs."
export default {
    date(date) {
        if (date) {
            return moment.utc(date).local().format("DD.MM.YYYY");
        } else {
            return "";
        }
    },

    dateTime(dateTime) {
        if (dateTime) {
            return moment.utc(dateTime).local().format("DD.MM.YYYY h:mm:ss a");
        } else {
            return "";
        }
    },

    // The API sends naive UTC timestamps ("2026-08-31T11:23:40.89", no zone).
    // moment.utc() reads them as UTC, and still honours an explicit Z/offset
    // when one is present, so this is safe for both shapes. Use it instead of
    // `new Date(value)`, which would read a naive string as *local* time.
    toDate(value) {
        if (!value) {
            return null;
        }
        const parsed = moment.utc(value);
        return parsed.isValid() ? parsed.toDate() : null;
    },

    // True when a naive-UTC timestamp is in the past.
    isPast(value) {
        const date = this.toDate(value);
        return !!date && date.getTime() < Date.now();
    },

    currency(_currency) {
        if (typeof _currency === 'number') {
            var formatter = new Intl.NumberFormat('en-IN');
            return _currencyType + formatter.format(_currency);
        } else {
            return _currencyType + 0;
        }
    },
}